import React from 'react';
import AppointmentCalendar from './AppointmentCalendar';
import AppointmentDayModal from './AppointmentDayModal';
import HospitalSelector from './shared/HospitalSelector';
import DoctorSelector from './shared/DoctorSelector';
import { searchDoctors } from './ArticleFormNew/api';
import { statusColor, LEGEND_STATUSES, STATUS_LABEL_KEYS } from './shared/appointmentStatus';

const MODES = ['month', 'week', 'day'];

// The full-page calendar: the toolbar and filters live here, the grid and its feed
// stay in AppointmentCalendar so the doctor tab and this page share one renderer.
export default class AppointmentCalendarPage extends React.Component {
  state = {
    mode: 'month',
    hospitals: [],
    hospitalId: '',
    doctor: null,
    searchText: '',
    q: '',
    openDay: null,
  };

  componentDidMount() {
    // PE-438: the statistics year heatmap links here with ?date=YYYY-MM-DD —
    // open that day's modal straight away.
    const date = new URLSearchParams(window.location.search).get('date');
    if (date && /^\d{4}-\d{2}-\d{2}$/.test(date)) this.setState({ openDay: date });

    // HospitalSelector filters client-side, so it wants the whole list once.
    fetch('/api/search/hospitals')
      .then(response => (response.ok ? response.json() : []))
      .then(hospitals => {
        if (this.unmounted) return;
        this.setState({ hospitals: Array.isArray(hospitals) ? hospitals : [] });
      })
      .catch(() => {});
  }

  componentWillUnmount() {
    this.unmounted = true;
    clearTimeout(this.searchTimer);
  }

  handleSearch = (event) => {
    const searchText = event.target.value;
    this.setState({ searchText });
    clearTimeout(this.searchTimer);
    // One request per pause in typing, not one per keystroke.
    this.searchTimer = setTimeout(() => this.setState({ q: searchText }), 300);
  };

  filters = () => ({
    hospital_id: this.props.hospital_id || this.state.hospitalId,
    doctor_id: this.state.doctor ? this.state.doctor.id : '',
    q: this.state.q,
  });

  renderModes() {
    const { labels } = this.props;
    const { mode } = this.state;

    return (
      <div className="appointment-calendar__modes" role="group" aria-label={labels.view_switch}>
        {MODES.map(key => (
          <button
            key={key}
            type="button"
            className={`appointment-calendar__mode${mode === key ? ' is-active' : ''}`}
            aria-pressed={mode === key}
            onClick={() => this.setState({ mode: key })}
          >
            {labels[`${key}_view`]}
          </button>
        ))}
      </div>
    );
  }

  renderFilters() {
    const { labels, hospital_id: lockedHospital } = this.props;
    const { hospitals, hospitalId, doctor, searchText } = this.state;

    return (
      <div className="appointment-calendar__filters">
        {/* A branch admin is already scoped server-side, so the picker would be a
            control that cannot change anything. */}
        {!lockedHospital && (
          <div className="appointment-calendar__filter">
            <HospitalSelector
              hospitals={hospitals}
              selectedId={hospitalId}
              onSelect={id => this.setState({ hospitalId: id })}
              onClear={() => this.setState({ hospitalId: '' })}
              translations={labels}
            />
          </div>
        )}

        <div className="appointment-calendar__filter">
          <DoctorSelector
            variant="dropdown"
            multiple={false}
            selectedDoctors={doctor ? [doctor] : []}
            onSelect={selected => this.setState({ doctor: selected })}
            onRemove={() => this.setState({ doctor: null })}
            searchDoctors={searchDoctors}
            translations={labels}
          />
        </div>

        <div className="appointment-calendar__filter appointment-calendar__filter--search form-group">
          <i className="zmdi zmdi-search appointment-calendar__search-icon" aria-hidden="true" />
          <input
            type="text"
            className="form-control"
            placeholder={labels.search_placeholder}
            value={searchText}
            onChange={this.handleSearch}
          />
          <i className="form-group__bar" />
        </div>

        <div className="appointment-calendar__legend">
          {LEGEND_STATUSES.map(status => (
            <span className="appointment-calendar__legend-item" key={status}>
              <span
                className="appointment-calendar__legend-dot"
                style={{ backgroundColor: statusColor(status) }}
              />
              {labels[STATUS_LABEL_KEYS[status]]}
            </span>
          ))}
        </div>
      </div>
    );
  }

  render() {
    const { labels, locale, hospital_id: lockedHospital } = this.props;
    const { mode, openDay, hospitals, hospitalId, doctor } = this.state;

    return (
      <div className="appointment-calendar-page">
        <AppointmentCalendar
          aggregate
          mode={mode}
          labels={labels}
          locale={locale}
          filters={this.filters()}
          viewSwitch={this.renderModes()}
          toolbarExtra={this.renderFilters()}
          onDayClick={date => this.setState({ openDay: date })}
        />

        {openDay && (
          <AppointmentDayModal
            date={openDay}
            labels={labels}
            locale={locale}
            hospitals={hospitals}
            hospitalId={lockedHospital || hospitalId}
            lockedHospital={Boolean(lockedHospital)}
            doctor={doctor}
            onClose={() => this.setState({ openDay: null })}
          />
        )}
      </div>
    );
  }
}
